import { gql } from '@apollo/client';

export const fetchOrdersForRewind = gql`
  query fetchOrdersForRewindOnEntitlement($id: String) {
    entitlementDetails(id: $id) {
      id
      ordersForRewind {
        totalCount
        nodes {
          id
          orderNumber
          created
          billingGroup {
            billingGroupId
          }
          orderLineItems {
            nodes {
              lineItemId
              entitlementId
              parentEntitlementId
              entitlementNumber
              pricingPlanId
              status
              type
              quantity
              pricingPlan {
                type
                billingFrequency
              }
              offering {
                name
                id
              }
              promotionCodes
              promotions {
                id
                title
                benefits {
                  benefitType
                  subBenefitType
                  iterations
                  value
                  scale
                  type
                  duration
                  customisable {
                    value {
                      type
                      lowerBound
                      upperBound
                    }
                    iterations {
                      type
                      lowerBound
                      upperBound
                    }
                    duration
                  }
                }
                promotionWindow {
                  endTime
                  startTime
                }
                status
                cycleInterval
                pricingType
                eligibilityRules {
                  products
                  cycleInterval
                  pricingType
                  partnerType
                  partnerTier
                  saleTransitionType
                  currency
                }
                applicationReason {
                  id
                  readableName
                  customisable {
                    id {
                      type
                      anyOf {
                        readableName
                        id
                      }
                    }
                  }
                }
                isPromotionCustomisable
              }
              orderTransitionType
              salesTransitionType
            }
          }
          contextSubject
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
